<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none">
                        <path d="m11.769 5.322 5.945 5.888L8.1 20.81a4.5 4.5 0 0 1-1.278.65 54 54 0 0 1-5.282 1.466c-1.003.216-1.611-.114-1.498-1.225.824-2.256.945-5 2.322-6.978l9.408-9.399zM17.079.998a3.22 3.22 0 0 1 1.92.448c.66.398 2.46 2.262 2.755 2.96 1.023 2.415-1.12 3.828-2.573 5.317l-5.946-5.887c1.189-1.032 2.14-2.68 3.844-2.838"/>
                    </svg>
</template>


